import api from "./api";

/**
 * @file reports.js
 * @description Servicio HTTP de la sección "Reportes" del Dashboard.
 *              Pega contra `/embedding/*` del backend que firma JWT para
 *              embebir dashboards de Metabase.
 */

const reportsService = {};
const endpoint = () => `/embedding`;

/**
 * @description Lista de dashboards disponibles para el tenant del usuario
 *              actual. El backend filtra por la `Organization.key` del JWT
 *              y solo devuelve los que tienen ID de Metabase configurado.
 * @returns {Promise<{ docs: Array<{key: string}>, total: number }>}
 */
reportsService.listDashboards = function () {
  return api.get(`${endpoint()}/dashboards`).then((res) => res.data);
};

/**
 * @description Devuelve la URL firmada para embebir el dashboard `key` del
 *              tenant del usuario actual. La URL tiene TTL ~10 min — para
 *              sesiones largas, refrescar la URL al detectar 401 del iframe.
 * @param {string} key - clave del dashboard (ej. 'operativo-general')
 * @returns {Promise<{ url: string, expiresAt: number }>}
 */
reportsService.getDashboardEmbedUrl = function (key) {
  return api.get(`${endpoint()}/dashboards/${key}`).then((res) => res.data);
};

export default reportsService;
